import React from 'react';
import { useAnimatedCounter } from '../../hooks/useAnimatedCounter';

interface AnimatedCounterProps {
  end: number;
  prefix?: string;
  suffix?: string;
  className?: string;
  duration?: number;
}

export default function AnimatedCounter({
  end,
  prefix = '',
  suffix = '',
  className = '',
  duration = 2000,
}: AnimatedCounterProps) {
  const { count, ref } = useAnimatedCounter(end, duration);

  return (
    <div ref={ref} className={className}>
      {prefix}
      {count}
      {suffix}
    </div>
  );
}
